'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../node_modules/tslib/tslib.es6.js');
var jsxRuntime = require('react/jsx-runtime');

var SvgFilePdf64 = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = tslib_es6.__rest(_a, ["title", "titleId"]);
    return (jsxRuntime.jsxs("svg", tslib_es6.__assign({ width: 64, height: 64, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg", role: "img", "aria-labelledby": titleId }, props, { children: [title ? jsxRuntime.jsx("title", tslib_es6.__assign({ id: titleId }, { children: title })) : null, jsxRuntime.jsxs("g", tslib_es6.__assign({ fill: "none", fillRule: "evenodd" }, { children: [jsxRuntime.jsx("path", { fill: "none", d: "M0 .5h64v64H0z" }), jsxRuntime.jsx("path", { d: "M47 24.5H36v-11m11 11.138V51.5H16v-38h20.02L47 24.638h0ZM30.41 38.633c1.659-4.614 2.527-9.605 0-9.125-2.525.48-.705 5.078 1.184 8.166 1.89 3.088 5.477 6.549 7.005 4.538 1.528-2.01-2.493-3.143-7.3-2.851-4.805.291-8.222 3.414-6.653 4.59 1.57 1.175 4.107-.705 5.765-5.318Z", strokeLinecap: "square", stroke: "currentColor" })] }))] })));
};

exports.default = SvgFilePdf64;
